import React, {useContext, useEffect, useState} from 'react';
import './App.scss';
import {BrowserRouter as Router} from 'react-router-dom';
import {ThemeContext} from "./context/ThemeContext";
import {Theme} from "./models/theme.model";
import styled, {createGlobalStyle} from "styled-components";
import {PreviewProvider} from "./context/PreviewContext";
import {PreloaderProvider} from "./context/PreloaderContext";
import {MainPage} from "./page/MainPage/MainPage";
import {PageProvider} from "./context/PageContext";
import {getApiUrl} from "./utils/util-functions";

const TopBorderElement = styled.div`
      background: ${props => props.theme.branding_color};
`;

const GlobalStyle = createGlobalStyle`
  body {
    background: ${props => (props.theme as Theme).background_color};
  }
`;

function App() {
    const theme: Theme = useContext(ThemeContext).theme;
    const [baseName, setBaseName] = useState<string>('');

    useEffect(()=>{
        setBaseName(window.location.pathname);
    })

    return (
        <Router basename={baseName}>
            <GlobalStyle theme={theme} />
            <PreloaderProvider>
                <TopBorderElement theme={theme} className="top-border-element"/>
                <PreviewProvider>
                    <PageProvider>
                        <MainPage/>
                    </PageProvider>
                </PreviewProvider>
            </PreloaderProvider>
        </Router>
    );
}

export default App;
